import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { Formatter } from 'shared'
import DatePicker from 'react-datepicker';
import { useEffect, useState } from 'react';

const ParkReservationCalendar = ({ park, date, serviceId, service, base }) => {

  // State
  const [state, setState] = useState({ date: null, time: null, timeSlots: null, soldOutDates: [] })

  // Consts
  const loadedSoldOutMonths = {}

  // Hooks
  useEffect(() => {
    loadSoldOutDates(date && date.toDate() || application.todayDate)
  }, [])

  // Custom Methods
  const loadSoldOutDates = async date => {
    let month = moment(date).format('YYYY-MM')
    let key = [month, serviceId].join('__')
    if (!loadedSoldOutMonths[key]) {
      loadedSoldOutMonths[key] = true
      let reservedDates = await ParkApi.getFullyReservedDates(park, month, serviceId)
      setState(prev => ({ ...prev, soldOutDates: state.soldOutDates.concat(reservedDates) }))
    }
  }
  const monthChanged = date => { loadSoldOutDates(date) }
  const resetDate = () => { application.go(application.router.parkReservation(base, park, service)) }
  const resetService = () => { application.go(application.router.parkReservation(base, park)) }
  const updateDate = async date => { application.go(application.router.parkReservation(base, park, service, date)) }

  // render
  return (
    <div className="park-reservation-datepicker custom-calendar">
      <h5 className='custom-calendar-heading event-information-detail'>Reserve this Location</h5>
      <div className="datepicker-wrapper">
        <DatePicker
          inline
          selected={date && date.toDate()}
          onChange={updateDate}
          minDate={application.todayDate} maxDate={moment(application.todayDate).add(1, 'year').toDate()}
          excludeDates={park.closedDateObjects}
          dayClassName={date => state.soldOutDates.includes(moment(date).format('YYYY-MM-DD')) ? 'day-booked' : undefined}
          // dayClassName={date => park.bookedOnDate(date) ? 'day-booked' : undefined}
          onMonthChange={monthChanged}
        />
        <div className="text-muted text-sm text-center">
          {service &&
            <div>
              <span className="icon-btn-with-text">
                {service.name}
                <i className="icon-btn" onClick={resetService} title="Reset service">
                  <FontAwesomeIcon icon={faTimesCircle} />
                </i>
              </span>
            </div>
          }
          {date &&
            <div>
              <span className="icon-btn-with-text">
                {Formatter.dateUS(date)}
                <i className="icon-btn" onClick={resetDate} title="Reset dates">
                  <FontAwesomeIcon icon={faTimesCircle} />
                </i>
              </span>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default ParkReservationCalendar
